import React, { Component } from "react";
import axios from "axios";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  withStyles,
  Button,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  withWidth,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";

import dialCodes from "../../config/dialCodes";
import { URL } from "../../config/config";
import { expandPermissionSchema } from "../../helpers/accessControlHelper";
import { withReadOnlyLoginDefault } from "../../helpers/ownerLogin.helper";

class CreateRoleDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      permissions: this.getInitialPermissionState(),
      createRoleLoading: false,
      isEditing: false,
      editingRoleId: null,
    };
  }

  // Permission tree definition based on the provided list
  static permissionTree = [
    {
      label: "Reporting",
      key: "reporting",
      read: true,
    },
    {
      label: "Templates",
      key: "template-messages",
      read: true,
      write: true,
    },
    {
      label: "Assistants",
      key: "assistants",
      read: true,
      write: true,
      actions: [
        { label: "Login", key: "login" },
        { label: "Read only login", key: "readOnlyLogin" },
        { label: "View logs", key: "viewLogs" },
        { label: "Search only (hide table)", key: "assistantSearchOnly" },
      ],
      subroutes: [
        { label: "Waba", key: "waba", read: true, write: true },
        { 
          label: "FB Manager", 
          key: "fbManager", 
          read: true, 
          write: true, 
          actions: [
            { label: "Assign Asset", key: "assignAsset" },
          ] 
        },
        { label: "Finance", key: "finance", read: true, write: true },
        {
          label: "Platform Config",
          key: "platformConfig",
          read: true,
          write: true,
        },
        {
          label: "Plan management",
          key: "planManagement",
          read: true,
          write: true,
        },
        { label: "Flows", key: "flows", read: true, write: true },
        {
          label: "Dev area",
          key: "devArea",
          read: true,
          write: true,
          actions: [
            { label: "Send Message Encryption", key: "sendMessageEncryption" },
            { label: "Custom Webhook Config", key: "customWebhookConfig" },
          ],
        },
        { label: "Logs", key: "logs", read: true, write: true },
        { label: "Extras", key: "extras", read: true, write: true },
        { label: "Meta Ads", key: "metaAds", read: true, write: true },
        { label: "Forms", key: "forms", read: true, write: true },
        { label: "Google Ads", key: "googleAds", read: true, write: true },
      ],
    },
    {
      label: "Kyc signal",
      key: "kyc",
      read: true,
      actions: [{ label: "Report", key: "report" }],
      subroutes: [
        { label: "Aisensy", key: "aisensy", read: true, write: true },
        { label: "Partners", key: "partners", read: true, write: true },
        { label: "Indiamart", key: "indiamart", read: true, write: true },
      ],
    },
    {
      label: "Rewards",
      key: "rewards",
      read: true,
      write: true,
    },
    {
      label: "Affiliates",
      key: "affiliates",
      read: true,
      actions: [{ label: "Add Affiliate", key: "addAffiliate" }],
      subroutes: [
        {
          label: "Regular",
          key: "regular",
          read: true,
          write: true,
          actions: [
            { label: "Login", key: "login" },
            { label: "View logs", key: "viewLogs" },
          ],
        },
        {
          label: "Growth",
          key: "growth",
          read: true,
          write: true,
          actions: [
            { label: "Login", key: "login" },
            { label: "View logs", key: "viewLogs" },
          ],
        },
        {
          label: "Integration",
          key: "integration",
          read: true,
          write: true,
          actions: [
            { label: "Login", key: "login" },
            { label: "View logs", key: "viewLogs" },
          ],
        },
      ],
    },
    {
      label: "Offer Codes",
      key: "diwali-offer-codes",
      read: true,
      subroutes: [
        {
          label: "Customer Data",
          key: "customerData",
          read: true,
          write: true,
          actions: [{ label: "Access Codes", key: "accessCodes" }],
        },
        {
          label: "Analytics",
          key: "analytics",
          read: true,
        },
      ],
    },
    {
      label: "Evolve Dubai",
      key: "dubai-evolve",
      read: true,
      actions: [{ label: "Export report", key: "exportReport" }],
    },
    {
      label: "Clients",
      key: "clients",
      read: true,
      write: true,
    },
    {
      label: "Orders",
      key: "orders",
      read: true,
      write: true,
    },
    {
      label: "Payment Analytics",
      key: "payment-analytics",
      read: true,
      actions: [{ label: "Add note", key: "addNote" }],
    },
    {
      label: "Checkout Analytics",
      key: "checkout-analytics",
      read: true,
    },
    {
      label: "Checkout Products",
      key: "checkout-products",
      read: true,
      write: true,
    },
    {
      label: "Agent Analytics",
      key: "agent-analytics",
      read: true,
      write: true,
    },
    {
      label: "Ad Template Analytics",
      key: "ad-template-analytics",
      read: true,
    },
    {
      label: "Meta Ads Journey",
      key: "meta-ads-journey",
      read: true,
    },
    {
      label: "Google Ads Pilot Console",
      key: "google-ads-pilot-console",
      read: true,
    },
    {
      label: "Spam Review",
      key: "spam-review",
      read: true,
      write: true,
    },
    {
      label: "Template Library",
      key: "library",
      read: true,
      write: true,
      actions: [{ label: "Create", key: "create" }],
    },
    {
      label: "Flow Library",
      key: "flow-library",
      read: true,
      write: true,
      actions: [{ label: "Create", key: "create" }],
    },
    {
      label: "Partners",
      key: "partners",
      read: true,
      write: true,
      actions: [
        { label: "Report", key: "report" },
        { label: "Add partner", key: "addPartner" },
        { label: "Generate Partner from", key: "generatePartnerForm" },
      ],
      subroutes: [
        {
          label: "Whitelabels",
          key: "whitelabels",
          read: true,
          actions: [
            { label: "View logs", key: "viewLogs" },
            { label: "Owner login", key: "ownerLogin" },
          ],
          subroutes: [
            {
              label: "Partner Management",
              key: "partnerManagement",
              read: true,
              write: true,
            },
            {
              label: "Partner Configs",
              key: "partnerConfigs",
              read: true,
              write: true,
            },
            {
              label: "Tsp configuration",
              key: "tspConfiguration",
              read: true,
              write: true,
            },
            {
              label: "Pricing management",
              key: "pricingManagement",
              read: true,
              write: true,
            },
            {
              label: "Assistants",
              key: "pmAssistants",
              read: true,
              write: true,
            },
            {
              label: "Reports",
              key: "pmReports",
              read: true,
            },
            { label: "Controls", key: "controls", read: true, write: true },
            {
              label: "Finance",
              key: "finance",
              read: true,
              write: true,
            },
          ],
        },
        {
          label: "Direct",
          key: "direct",
          read: true,
          actions: [
            { label: "View logs", key: "viewLogs" },
            { label: "Owner login", key: "ownerLogin" },
          ],
          subroutes: [
            {
              label: "Partner Management",
              key: "partnerManagement",
              read: true,
              write: true,
            },
            {
              label: "Partner Configs",
              key: "partnerConfigs",
              read: true,
              write: true,
            },
            {
              label: "Tsp configuration",
              key: "tspConfiguration",
              read: true,
              write: true,
            },
            {
              label: "Pricing management",
              key: "pricingManagement",
              read: true,
              write: true,
            },
            {
              label: "Assistants",
              key: "pmAssistants",
              read: true,
              write: true,
            },
            {
              label: "Reports",
              key: "pmReports",
              read: true,
            },
            { label: "Controls", key: "controls", read: true, write: true },
            {
              label: "Finance",
              key: "finance",
              read: true,
              write: true,
            },
          ],
        },
        {
          label: "Ads whitelabel",
          key: "adsWhitelabel",
          read: true,
          actions: [
            { label: "View logs", key: "viewLogs" },
            { label: "Owner login", key: "ownerLogin" },
          ],
          subroutes: [
            {
              label: "Partner Management",
              key: "partnerManagement",
              read: true,
              write: true,
            },
            {
              label: "Partner Configs",
              key: "partnerConfigs",
              read: true,
              write: true,
            },
            {
              label: "Tsp configuration",
              key: "tspConfiguration",
              read: true,
              write: true,
            },
            {
              label: "Pricing management",
              key: "pricingManagement",
              read: true,
              write: true,
            },
            {
              label: "Assistants",
              key: "pmAssistants",
              read: true,
              write: true,
            },
            {
              label: "Reports",
              key: "pmReports",
              read: true,
            },
            { label: "Controls", key: "controls", read: true, write: true },
            {
              label: "Finance",
              key: "finance",
              read: true,
              write: true,
            },
          ],
        },
      ],
    },
    {
      label: "Virtual Numbers",
      key: "virtual-numbers",
      read: true,
      actions: [
        { label: "Add Number", key: "addNumber" },
        { label: "Trigger OTP", key: "triggerOTP" },
      ],
    },
    {
      label: "Dashboard",
      key: "dashboard",
      read: true,
      actions: [
        { label: "Search OTP", key: "searchOTP" },
        { label: "Search payment", key: "searchPayment" },
        { label: "Search project", key: "searchProject" },
      ],
    },
    {
      label: "Employee",
      key: "employee",
      read: true,
      write: true,
      actions: [
        { label: "Create Agent", key: "createAgent" },
        { label: "Create Role", key: "createRole" },
      ],
    },
    {
      label: "Velocity",
      key: "velocity",
      read: true,
      write: true,
    },
    {
      label: "Marketplace",
      key: "marketplace",
      read: true,
      write: true,
    },
  ];

  // Helper to initialize checked state for the permission tree
  getInitialPermissionState = (tree = CreateRoleDialog.permissionTree) => {
    return tree.map((item) => ({
      key: item.key,
      read: false,
      write: false,
      actions: item.actions ? [] : undefined,
      subroutes: item.subroutes
        ? this.getInitialPermissionState(item.subroutes)
        : undefined,
    }));
  };

  componentDidUpdate(prevProps) {
    // Only trigger when dialog transitions from closed to open
    if (!prevProps.dialogOpen && this.props.dialogOpen) {
      // Reset state when dialog opens
      const newState = this.props.editingRole
        ? {
          name: this.props.editingRole.name,
          permissions:
            expandPermissionSchema(this.props.editingRole.permissions) ||
            this.getInitialPermissionState(),
          isEditing: true,
          editingRoleId: this.props.editingRole._id,
        }
        : {
          name: "",
          // MSG-606: new roles start with read-only owner login.
          permissions: withReadOnlyLoginDefault(this.getInitialPermissionState()),
          isEditing: false,
          editingRoleId: null,
        };

      // Set state once when dialog opens
      this.setState(newState);
    }
  }

  handleNameChange = (e) => {
    this.setState({ name: e.target.value });
  };

  // Recursive handler for toggling permissions
  handlePermissionChange =
    (path, type, idx = null) =>
      (e) => {
        const { permissions } = this.state;
        const stateArr = CreateRoleDialog.permissionTree;

        const update = (arr, p) => {
          if (p.length === 0) return arr;
          const [head, ...rest] = p;
          return arr.map((item, i) => {
            if (i !== head) return item;
            if (rest.length === 0) {
              if (type === "read" || type === "write") {
                const updatedItem = { ...item, [type]: e.target.checked };

                // If write is being checked, also check read
                if (type === "write" && e.target.checked) {
                  updatedItem.read = true;
                }

                // If read is being unchecked, uncheck all child permissions
                if (type === "read" && !e.target.checked) {
                  updatedItem.write = false;
                  updatedItem.actions = [];
                  // Recursively uncheck all subroute permissions
                  if (updatedItem.subroutes) {
                    updatedItem.subroutes = this.uncheckAllSubroutePermissions(
                      updatedItem.subroutes
                    );
                  }
                }

                return updatedItem;
              } else if (type === "action" && idx !== null) {
                let newActions = item.actions || [];
                if (path.length > 1) {
                  const index = path[0];
                  const subIndex = path[1];
                  const actionKey =
                    stateArr[index].subroutes[subIndex].actions[idx].key;
                  if (e.target.checked) {
                    if (!newActions.includes(actionKey))
                      newActions.push(actionKey);
                  } else {
                    newActions = newActions.filter((k) => k !== actionKey);
                  }
                } else {
                  const index = path[0];
                  const actionKey = stateArr[index].actions[idx].key;
                  if (e.target.checked) {
                    if (!newActions.includes(actionKey))
                      newActions.push(actionKey);
                  } else {
                    newActions = newActions.filter((k) => k !== actionKey);
                  }
                }

                const updatedItem = { ...item, actions: newActions };

                // If action is being checked, also check read
                if (e.target.checked) {
                  updatedItem.read = true;
                }

                return updatedItem;
              }
            } else {
              const updatedSubroutes = update(item.subroutes || [], rest);

              // Check if any subroute has permissions selected
              const hasSubroutePermissions =
                this.checkSubroutePermissions(updatedSubroutes);

              return {
                ...item,
                subroutes: updatedSubroutes,
                // If any subroute has permissions, ensure parent read is checked
                read: hasSubroutePermissions ? true : item.read,
              };
            }
            return item;
          });
        };

        this.setState({ permissions: update(permissions, path) });
      };

  // Helper method to uncheck all permissions in subroutes recursively
  uncheckAllSubroutePermissions = (subroutes) => {
    return subroutes.map((subroute) => ({
      ...subroute,
      read: false,
      write: false,
      actions: [],
      subroutes: subroute.subroutes
        ? this.uncheckAllSubroutePermissions(subroute.subroutes)
        : undefined,
    }));
  };

  // Helper method to check if any subroute has permissions selected
  checkSubroutePermissions = (subroutes) => {
    return subroutes.some((subroute) => {
      // Check if this subroute has read, write, or actions selected
      const hasPermissions =
        subroute.read ||
        subroute.write ||
        (subroute.actions && subroute.actions.length > 0);

      // Recursively check sub-subroutes
      const hasSubSubroutePermissions = subroute.subroutes
        ? this.checkSubroutePermissions(subroute.subroutes)
        : false;

      return hasPermissions || hasSubSubroutePermissions;
    });
  };

  // Recursively render permission checkboxes
  renderPermissionTree = (tree, stateArr, path = []) => {
    // Ensure stateArr is an array and has the same length as tree
    if (!Array.isArray(stateArr) || stateArr.length !== tree.length) {
      // If stateArr doesn't match tree structure, initialize it properly
      stateArr = this.getInitialPermissionState(tree);
    }

    return tree.map((item, i) => {
      let stateItem = stateArr[i];
      if (!stateItem) {
        stateItem = {
          key: item.key,
          read: false,
          write: false,
          actions: item.actions ? [] : undefined,
          subroutes: item.subroutes
            ? this.getInitialPermissionState(item.subroutes)
            : undefined,
        };
      } else {
        // Ensure stateItem has all required properties
        stateItem = {
          key: stateItem.key || item.key,
          read: stateItem.read || false,
          write: stateItem.write || false,
          actions: stateItem.actions || (item.actions ? [] : undefined),
          subroutes:
            stateItem.subroutes ||
            (item.subroutes
              ? this.getInitialPermissionState(item.subroutes)
              : undefined),
        };
      }

      const { classes } = this.props;

      return (
        <div key={item.key} className={classes.permissionGroup}>
          <Typography className={classes.permissionLabel}>
            {item.label}
          </Typography>
          <div className={classes.checkboxGroup}>
            {item.read !== undefined && (
              <div
                className={`${classes.readCheckbox} ${!!stateItem.read ? classes.readCheckboxChecked : ""
                  }`}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!stateItem.read}
                      onChange={this.handlePermissionChange(
                        [...path, i],
                        "read"
                      )}
                      size="small"
                      color="primary"
                    />
                  }
                  label="Read"
                />
              </div>
            )}
            {item.write !== undefined && (
              <div
                className={`${classes.otherCheckbox} ${!!stateItem.write ? classes.otherCheckboxChecked : ""
                  }`}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!stateItem.write}
                      onChange={this.handlePermissionChange(
                        [...path, i],
                        "write"
                      )}
                      size="small"
                      color="primary"
                    />
                  }
                  label="Write"
                />
              </div>
            )}
            {item.actions && item.actions.length > 0 && (
              <>
                {item.actions.map((action, idx) => (
                  <div
                    key={action.key}
                    className={`${action.key === "searchProject"
                      ? classes.searchProjectCheckbox
                      : classes.otherCheckbox
                      } ${Array.isArray(stateItem.actions) &&
                        stateItem.actions.includes(action.key)
                        ? action.key === "searchProject"
                          ? classes.searchProjectCheckboxChecked
                          : classes.otherCheckboxChecked
                        : ""
                      }`}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={
                            Array.isArray(stateItem.actions) &&
                            stateItem.actions.includes(action.key)
                          }
                          onChange={this.handlePermissionChange(
                            [...path, i],
                            "action",
                            idx
                          )}
                          size="small"
                          color="primary"
                        />
                      }
                      label={action.label}
                    />
                  </div>
                ))}
              </>
            )}
          </div>
          {item.subroutes && item.subroutes.length > 0 && (
            <div className={classes.subroutes}>
              {this.renderPermissionTree(
                item?.subroutes,
                stateItem?.subroutes,
                [...path, i]
              )}
            </div>
          )}
        </div>
      );
    });
  };

  // Convert state to API schema
  buildPermissionSchema = (tree, schema = CreateRoleDialog.permissionTree) => {
    // Check if ALL permissions are selected globally
    const isAllGloballySelected = this.areAllPermissionsSelected();

    if (isAllGloballySelected) {
      // If all permissions are selected globally, return [{*: true}]
      return [{ "*": true }];
    }

    return tree.map((item, index) => {
      const schemaItem = schema[index];

      // Check if all permissions and actions for this item are selected
      const isAllSelected = this.isItemFullySelected(item, schemaItem);

      if (isAllSelected) {
        // If all permissions and actions are selected, use *: true
        const obj = {
          label: schemaItem.key,
          "*": true,
        };

        // Handle subroutes recursively
        if (item.subroutes && schemaItem.subroutes) {
          const sub = this.buildPermissionSchema(
            item.subroutes,
            schemaItem.subroutes
          );
          // If all subroutes are also fully selected (all have *: true),
          // then we don't need to include subroutes in the result
          const allSubroutesFullySelected = sub.every(
            (subItem) => subItem["*"] === true
          );
          if (
            !allSubroutesFullySelected &&
            sub.some((s) => Object.keys(s).length > 0)
          ) {
            obj.subroutes = sub;
          }
        }

        return obj;
      } else {
        // If not all permissions are selected, use the detailed format
        const obj = {
          read: item.read,
          write: item.write,
          label: schemaItem.key,
        };

        if (item?.actions?.length) {
          obj.actions = item.actions;
        }

        if (item.subroutes && schemaItem.subroutes) {
          const sub = this.buildPermissionSchema(
            item.subroutes,
            schemaItem.subroutes
          );
          if (sub.some((s) => Object.keys(s).length > 0)) obj.subroutes = sub;
        }

        return obj;
      }
    });
  };

  // Helper method to check if an item has all permissions and actions selected
  isItemFullySelected = (item, schemaItem) => {
    // Check read permission
    if (schemaItem.read !== undefined && !item.read) {
      return false;
    }

    // Check write permission
    if (schemaItem.write !== undefined && !item.write) {
      return false;
    }

    // Check actions
    if (schemaItem.actions && schemaItem.actions.length > 0) {
      const expectedActions = schemaItem.actions.map((a) => a.key);
      const selectedActions = item.actions || [];
      if (
        !expectedActions.every((action) => selectedActions.includes(action))
      ) {
        return false;
      }
    }

    // Check subroutes recursively
    if (schemaItem.subroutes && item.subroutes) {
      return this.areSubroutesFullySelected(
        item.subroutes,
        schemaItem.subroutes
      );
    }

    return true;
  };

  // Helper method to check if all subroutes are fully selected
  areSubroutesFullySelected = (subroutes, schemaSubroutes) => {
    return subroutes.every((item, index) => {
      const schemaItem = schemaSubroutes[index];
      return this.isItemFullySelected(item, schemaItem);
    });
  };

  onCancel = () => {
    this.setState(
      {
        name: "",
        permissions: this.getInitialPermissionState(),
      },
      this.props.onClose
    );
  };

  onSubmit = () => {
    this.setState({ createRoleLoading: true });
    const { name, permissions, isEditing, editingRoleId } = this.state;

    if (!name?.trim()) {
      this.props.setAlert("error", "Role Name is required");
      this.setState({ createRoleLoading: false });
      return;
    }

    const builtPermissions = this.buildPermissionSchema(
      permissions,
      CreateRoleDialog.permissionTree
    );

    const endpoint = isEditing
      ? "/superadmin/edit-role"
      : "/superadmin/create-role";
    const payload = {
      name,
      permissions: builtPermissions,
      ...(isEditing && { roleId: editingRoleId }),
    };

    axios
      .post(URL + endpoint, payload)
      .then((response) => {
        this.props.setAlert(
          "success",
          `Role ${isEditing ? "Updated" : "Created"} Successfully`
        );
        this.props.loadData && this.props.loadData();
        this.onCancel();
        this.setState({ createRoleLoading: false });
      })
      .catch((error) => {
        console.error(error);
        this.props.setAlert(
          "error",
          error?.response?.data?.message || "Some error occurred"
        );
        this.setState({ createRoleLoading: false });
      });
  };

  getDialCode = () => {
    const result = dialCodes.filter((e) => e.name == this.state.country);
    return result[0].dialCode;
  };

  // Check if any permissions are selected
  areAnyPermissionsSelected = () => {
    const checkAnySelected = (tree) => {
      return tree.some((item) => {
        // Check if this item has any permissions selected
        const hasPermissions =
          item.read || item.write || (item.actions && item.actions.length > 0);

        // Recursively check subroutes
        const hasSubroutePermissions = item.subroutes
          ? checkAnySelected(item.subroutes)
          : false;

        return hasPermissions || hasSubroutePermissions;
      });
    };

    return checkAnySelected(this.state.permissions);
  };

  // Check if all permissions are currently selected
  areAllPermissionsSelected = () => {
    const checkAllSelected = (tree, schema) => {
      return tree.every((item, idx) => {
        const schemaItem = schema[idx];
        let itemSelected = true;

        // Check read permission
        if (schemaItem.read !== undefined && !item.read) {
          itemSelected = false;
        }

        // Check write permission
        if (schemaItem.write !== undefined && !item.write) {
          itemSelected = false;
        }

        // Check actions
        if (schemaItem.actions && schemaItem.actions.length > 0) {
          const expectedActions = schemaItem.actions.map((a) => a.key);
          const selectedActions = item.actions || [];
          if (
            !expectedActions.every((action) => selectedActions.includes(action))
          ) {
            itemSelected = false;
          }
        }

        // Check subroutes recursively
        if (schemaItem.subroutes && item.subroutes) {
          if (!checkAllSelected(item.subroutes, schemaItem.subroutes)) {
            itemSelected = false;
          }
        }

        return itemSelected;
      });
    };

    return checkAllSelected(
      this.state.permissions,
      CreateRoleDialog.permissionTree
    );
  };

  handleSelectAllPermissions = () => {
    const isAllSelected = this.areAllPermissionsSelected();

    if (isAllSelected) {
      // Unselect all permissions
      this.setState({ permissions: this.getInitialPermissionState() });
    } else {
      // Select all permissions
      const setAll = (tree) => {
        return tree.map((item) => {
          const newItem = {
            ...item,
            read: item.read !== undefined ? true : item.read,
            write: item.write !== undefined ? true : item.write,
            actions: item.actionsSchema
              ? item.actionsSchema.map((a) => a.key)
              : undefined,
            subroutes: item.subroutes ? setAll(item.subroutes) : undefined,
          };
          return newItem;
        });
      };

      // To get all possible action keys, we need to reference the permissionTree schema
      const applySchema = (tree, schema) => {
        return tree.map((item, idx) => {
          const schemaItem = schema[idx];
          return {
            ...item,
            actionsSchema: schemaItem.actions,
            subroutes:
              item.subroutes && schemaItem.subroutes
                ? applySchema(item.subroutes, schemaItem.subroutes)
                : undefined,
          };
        });
      };

      // Attach schema for actions
      const permissionsWithSchema = applySchema(
        this.state.permissions,
        CreateRoleDialog.permissionTree
      );

      // Set all permissions to true
      const allSelected = setAll(permissionsWithSchema);

      // Remove the temporary actionsSchema property
      const cleanAll = (tree) =>
        tree.map((item) => {
          const { actionsSchema, ...rest } = item;
          return {
            ...rest,
            subroutes: item.subroutes ? cleanAll(item.subroutes) : undefined,
          };
        });

      this.setState({ permissions: cleanAll(allSelected) });
    }
  };

  render() {
    const { classes, dialogOpen, onClose, width } = this.props;
    const { name, permissions, createRoleLoading } = this.state;
    return (
      <Dialog
        open={dialogOpen}
        onClose={onClose}
        disableBackdropClick
        fullScreen={width === "xs"}
      >
        <DialogTitle className={classes.title}>
          <Typography variant="h3">
            {this.state.isEditing ? "Edit Role" : "Create Role"}
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.content}>
          <Typography variant="h4">Role Name</Typography>
          <TextField
            value={name}
            onChange={this.handleNameChange}
            placeholder="Enter Role Name"
            fullWidth
            margin="normal"
            inputProps={{ maxLength: 1024 }}
          />
          <Box
            mt={2}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h4" className={classes.permissionTitle}>
              Permissions:
            </Typography>
            <Button
              size="small"
              variant="outlined"
              onClick={this.handleSelectAllPermissions}
            >
              {this.areAllPermissionsSelected() ? "Unselect All" : "Select All"}
            </Button>
          </Box>
          <Box mt={1}>
            {this.renderPermissionTree(
              CreateRoleDialog.permissionTree,
              permissions
            )}
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: "8px 32px 16px" }}>
          <Button variant="outlined" onClick={this.onCancel}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={this.onSubmit}
            disabled={
              !name?.trim() ||
              createRoleLoading ||
              !this.areAnyPermissionsSelected()
            }
          >
            {this.state.isEditing ? "Update" : "Create"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  title: {
    padding: "28px 24px 12px",
    [theme.breakpoints.down("xs")]: {
      padding: "24px 16px 8px",
    },
  },
  input: {
    margin: "0.5em",
  },
  content: {
    // width: "70vw",
    maxWidth: "500px",
    [theme.breakpoints.down("xs")]: {
      // width: "100%",
      padding: theme.spacing(2),
    },
  },
  permissionTitle: {
    marginRight: 8,
    [theme.breakpoints.down("xs")]: {
      marginRight: 0,
    },
  },
  permissionGroup: {
    marginBottom: 12,
  },
  permissionLabel: {
    fontWeight: 600,
    fontSize: "14px",
    marginBottom: 12,
  },
  checkboxGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: "24px",
    position: "relative",
    paddingLeft: 12,
  },
  readCheckbox: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 8,
      top: -14,
      height: 20,
      width: 2,
      backgroundColor: "#e0e0e0",
      transition: "background-color 0.2s",
    },
    [theme.breakpoints.down("xs")]: {
      "&::before": {
        display: "none",
      },
    },
  },
  readCheckboxChecked: {
    "&::before": {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down("xs")]: {
      "&::before": {
        display: "none",
      },
    },
  },
  otherCheckbox: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: -36,
      top: "50%",
      width: 32,
      height: 2,
      backgroundColor: "#e0e0e0",
      transition: "background-color 0.2s",
    },
    [theme.breakpoints.down("xs")]: {
      "&::before": {
        display: "none",
      },
    },
  },
  otherCheckboxChecked: {
    "&::before": {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down("xs")]: {
      "&::before": {
        display: "none",
      },
    },
  },
  searchProjectCheckbox: {
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 8,
      top: -30,
      height: 38,
      width: 2,
      backgroundColor: "#e0e0e0",
      transition: "background-color 0.2s",
    },
    [theme.breakpoints.down("xs")]: {
      "&::before": {
        display: "none",
      },
    },
  },
  searchProjectCheckboxChecked: {
    "&::before": {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down("xs")]: {
      "&::before": {
        display: "none",
      },
    },
  },
  subroutes: {
    paddingLeft: 40,
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: 20,
      top: 0,
      bottom: 20,
      width: 2,
      backgroundColor: "#e0e0e0",
    },
    [theme.breakpoints.down("xs")]: {
      "&::before": {
        display: "none",
      },
    },
  },
});

export default withWidth()(withStyles(styles)(CreateRoleDialog));
